// BL-2824 (PRJ-105 TXN-1) — the Transactions list's routes: one page of the
// house's ledger, and the footer's count and net over the same search. Both
// open on `payment.read` (M3, Michael Lawrie 2026-10-28). BL-2826 adds the
// picked quick-view tile (`view`) to both, and the tiles to the counts.
// BL-2831 adds Group by (`group`) to the page, with the page's groups.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only imports (erased at build) — keep the registry client-bundle-safe.
import type { TransactionListCountsDto, TransactionListPayloadDto } from '../../schemas/responses/transaction-list';

export const transactions = {
  index: defineAdminRoute({
    path: '/api/transactions',
    params: {},
    methods: {
      // One page of the house's ledger entries, searched and sorted on the server (ADR 059 — Search Spine).
      GET: {
        grant: 'payment.read',
        tenant: { from: 'input', field: 'tenantId', in: 'query' },
        response: responseType<TransactionListPayloadDto>(),
        query: { tenantId: '', page: '', pageSize: '', sortField: '', sortDir: '', search: '', view: '', group: '', ids: '' },
      },
    },
  }),
  // The footer (every row the search and the picked tile match, and the net money that moved) and the tiles.
  counts: defineAdminRoute({
    path: '/api/transactions/counts',
    params: {},
    methods: {
      GET: {
        grant: 'payment.read',
        tenant: { from: 'input', field: 'tenantId', in: 'query' },
        response: responseType<TransactionListCountsDto>(),
        query: { tenantId: '', search: '', view: '', ids: '' },
      },
    },
  }),
  // BL-2829 — the list as a CSV: the whole filter (the toolbar) or the `ids` a selection names (the bulk bar).
  // The success body is the file itself (text/csv); every failure keeps the JSON envelope.
  export: defineAdminRoute({
    path: '/api/transactions/export',
    params: {},
    methods: {
      GET: {
        grant: 'payment.read',
        tenant: { from: 'input', field: 'tenantId', in: 'query' },
        query: { tenantId: '', sortField: '', sortDir: '', search: '', view: '', ids: '', columns: '' },
      },
    },
  }),
};
